import React, { useState } from 'react';
import withStyles from 'react-jss';
import { useTranslation } from 'react-i18next';
import chevron from '../../../../ASUPhotos/icons/chevron.svg';

const rotateCaret = {
  rotate: () => ({
    transform: 'rotate(180deg)',
  }),
};

function CompareDegreesDropdown(props) {
  const { t } = useTranslation();
  const [caretIcon, setRotateCaret] = useState(false);
  const { tenant, showCompareDegreesSearchBar } = { ...props };

  const secondaryBackgroundColor = {
    backgroundColor: `${tenant.secondary}`,
  };

  // User has selected the compare career dropdown
  const handleCompareSelect = () => {
    setRotateCaret(!caretIcon);
    // Need to tell the Modal/parent component to display the career sections (i.e. Favorites, Top 25, All Careers)
    showCompareDegreesSearchBar();
  };

  return (
    <div>
      <div
        className="compare-careers"
        data-cy="compare-degrees-dropdown"
        style={secondaryBackgroundColor}
        onClick={handleCompareSelect}
        onKeyDown={(e) => {
          if (['Enter'].includes(e.key)) handleCompareSelect();
        }}
        tabIndex="0"
        role="button"
      >
        <p>{t('Compare Degree')}</p>
        <img
          className={['chevron', caretIcon ? props.classes.rotate : null].join(
            ' '
          )}
          alt="drop-down"
          src={chevron}
        />
      </div>
    </div>
  );
}

export default withStyles(rotateCaret)(CompareDegreesDropdown);
